import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

// Helper config for File Uploads
const getMultipartConfig = () => {
    // We pass 'null' (or undefined) for Content-Type to let the browser set the boundary automatically
    return getAxiosConfig({ 'Content-Type': null });
};

export const getProducts = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/products', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const fetchProduct = async (tagId, callback) => {
    try {
        const response = await risapi.get(`/api/products/${tagId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const createProduct = async (newProduct, callback) => {
    try {
        const formData = convertJsonToFormData(newProduct);
        // USE getMultipartConfig() HERE
        const response = await risapi.post('/api/products', formData, getMultipartConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const updateProduct = async (editProduct, callback) => {
    try {
        const formData = convertJsonToFormData(editProduct);
        formData.append('_method', 'put');
        
        // USE getMultipartConfig() HERE
        const response = await risapi.post(`/api/products/${editProduct.id}`, formData, getMultipartConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const destroyProduct = async (deleteProduct, callback) => {
    try {
        const response = await risapi.delete(`/api/products/${deleteProduct.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ product: deleteProduct });
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const destroyProductsMultiple = async (ids, callback) => {
    try {
        const sendData = {
            ids: ids,
            _method: 'delete'
        };
        const response = await risapi.post('/api/products/delete/multiple', sendData, getAxiosConfig());

        if (response.status === 204) {
            callback({ product: ids });
        }
    } catch (error) {
        callback({ error });
    }
};